import { c as _c } from "react/compiler-runtime";
import { SummaryStatisticsTableCell } from 'modules/mailing/email-statistics/components/summary-statistics-table/summary-statistics-table-cell';
import { SummaryStatistics } from 'modules/mailing/email-statistics/types/email-statistics-interface';
import { getStatistic } from 'modules/mailing/email-statistics/utils/get-statistic';
import { TextWithTooltipCell } from 'shared/components/table/cells/text-with-tooltip-cell';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const SummaryStatisticsTable = t0 => {
  const $ = _c(40);
  const {
    isLoading,
    summaryStatistics
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== summaryStatistics) {
    t1 = getStatistic(summaryStatistics);
    $[0] = summaryStatistics;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    clicksRate,
    openRate,
    spamReportRate,
    bouncedRate
  } = t1;
  const t2 = `mb-5 grid w-full grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4 ${isLoading ? "animate-pulse" : ""}`;
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.email_statistics.summary_statistics.open_rate");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== openRate) {
    t4 = <TextWithTooltipCell>{openRate}</TextWithTooltipCell>;
    $[4] = openRate;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isLoading || $[7] !== t3 || $[8] !== t4) {
    t5 = <SummaryStatisticsTableCell label={t3} value={t4} isLoading={isLoading} />;
    $[6] = isLoading;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("dashboard.email_statistics.summary_statistics.spam_report_rate");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== spamReportRate) {
    t7 = <TextWithTooltipCell>{spamReportRate}</TextWithTooltipCell>;
    $[12] = spamReportRate;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isLoading || $[15] !== t6 || $[16] !== t7) {
    t8 = <SummaryStatisticsTableCell label={t6} value={t7} isLoading={isLoading} />;
    $[14] = isLoading;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("dashboard.email_statistics.summary_statistics.clicks_rate");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== clicksRate) {
    t10 = <TextWithTooltipCell>{clicksRate}</TextWithTooltipCell>;
    $[20] = clicksRate;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isLoading || $[23] !== t10 || $[24] !== t9) {
    t11 = <SummaryStatisticsTableCell label={t9} value={t10} isLoading={isLoading} />;
    $[22] = isLoading;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("dashboard.email_statistics.summary_statistics.bounced_rate");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== bouncedRate) {
    t13 = <TextWithTooltipCell>{bouncedRate}</TextWithTooltipCell>;
    $[28] = bouncedRate;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== isLoading || $[31] !== t12 || $[32] !== t13) {
    t14 = <SummaryStatisticsTableCell label={t12} value={t13} isLoading={isLoading} />;
    $[30] = isLoading;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t11 || $[35] !== t14 || $[36] !== t2 || $[37] !== t5 || $[38] !== t8) {
    t15 = <div className={t2}>{t5}{t8}{t11}{t14}</div>;
    $[34] = t11;
    $[35] = t14;
    $[36] = t2;
    $[37] = t5;
    $[38] = t8;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
};